import { colors } from './colors';

export const shadows = {
  errorOutline: `0 0 0 3px ${colors.error[90]}`,
  floatingButton: `0px -4px 4px 0px rgba(0, 0, 0, 0.10)`,
  dropdown: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
  blueNavyInsetBorder: `0 0 0 3px ${colors.blueNavy} inset, 0px 4px 5.32px rgba(35, 35, 45, 0.24) inset,  0px 6.6501px 5.32008px rgba(35, 35, 45, 0.1), 0px 2.76726px 2.21381px rgba(195, 194, 209, 0.03)`,
  baseInsetBorder: `0 0 0 3px ${colors.base} inset, 0px 4px 5.32px rgba(35, 35, 45, 0.24) inset,  0px 6.6501px 5.32008px rgba(35, 35, 45, 0.1), 0px 2.76726px 2.21381px rgba(195, 194, 209, 0.03)`,
  inputActive: `0 0 0 4px #4F5DBA33`,
};
